import { useSelector } from "react-redux";
import { Typography, MultiSelect, Select } from "components";
import { getUniqueTransactionTypes } from "utils/helper";
import AsyncSelect from "react-select/async";
import debounce from "lodash.debounce";
import {
  getAllTransactionsData,
  setTransactionQuery,
  getTransactionDetails,
  searchAgent,
  setSearchedAgentValue,
} from "redux/actions/transactionActions";
import { getTerminalActivity } from "redux/actions/dashboard/terminalDashboardActions";

const TransactionHeader = () => {
  const { transactionTypes, transactionQuery, searchedAgent } = useSelector(
    (state) => ({
      user: state.user.user,
      transactionTypes: state.transactionsReducer.transactionTypes,
      transactionQuery: state.transactionsReducer.params,
      searchedAgent: state.transactionsReducer.searchedAgent,
    })
  );

  const agentSearchStyles = {
    control: (base) => ({
      ...base,
      border: "1px solid #102E88",
      width: "20rem",
      borderRadius: "12px",
    }),
    placeholder: (base) => ({ ...base, fontSize: "12px" }),
  };

  const _loadSuggestions = (searchValue, callback) => {
    searchAgent(searchValue).then((resp) => callback(resp));
  };

  const loadSuggestions = debounce(_loadSuggestions, 1000);

  return (
    <div>
      <div className="d-flex justify-content-end">
        <AsyncSelect
          cacheOptions
          loadOptions={loadSuggestions}
          styles={agentSearchStyles}
          value={searchedAgent}
          placeholder="Search with Agent Code, ID or Name"
          onChange={(val) => {
            setSearchedAgentValue(val || {});
            setTransactionQuery({
              name: "agentId",
              value: val?.value || "",
            });

            getAllTransactionsData();
            getTerminalActivity(val?.value || "");
          }}
          loadingMessage={() => "Searching Agents..."}
          // noOptionsMessage={() => "No Agents"}
          isClearable
        />
      </div>
      <div className="d-flex justify-content-end mt-3">
        <div className="transaction-spec-container">
          {transactionTypes?.length ? (
            <div>
              <div
                className={`transaction-choice-container d-flex align-items-center px-2 mb-2 transaction-choice-container__custom`}
              >
                <Typography variant="body3">Transaction Type:</Typography>{" "}
                <MultiSelect
                  placeholder={"All Transactions"}
                  // value={selectedTransactionTypes}
                  isSearchable={false}
                  clearable={false}
                  handleChange={(val) =>
                    setTransactionQuery({
                      name: "type",
                      value: val,
                    })
                  }
                  options={getUniqueTransactionTypes(transactionTypes)?.map(
                    ({ type, description }) => ({
                      label: description,
                      value: type,
                    })
                  )}
                  onBlur={() => getAllTransactionsData()}
                  name="transaction-type-select"
                  borderStyle={"none"}
                />
              </div>
              <div
                className="d-flex justify-content-end flex-wrap mb-2"
                style={{ maxWidth: "15rem" }}
              >
                {transactionQuery.type.length ===
                  getUniqueTransactionTypes(transactionTypes)?.length ||
                !transactionQuery.type.length ? (
                  <Typography variant="caption0">All Transactions</Typography>
                ) : (
                  transactionQuery.type.map((transaction, i) => (
                    <Typography variant="caption0" key={i}>
                      {transaction.label}
                      {i === transactionQuery.type.length - 1 ? "." : ","}{" "}
                      &nbsp;
                    </Typography>
                  ))
                )}
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="transaction-mode-container">
            <Typography variant="body3">
              Transaction Mode:{" "}
              <Select
                placeholder="All"
                required={false}
                options={[
                  {
                    label: "All",
                    value: "",
                  },
                  {
                    label: "Cash",
                    value: "CASH",
                  },
                  {
                    label: "Card",
                    value: "CARD",
                  },
                ]}
                value={transactionQuery.transMode}
                onChange={(e) => {
                  setTransactionQuery({
                    name: "transMode",
                    value: e.target.value,
                  });
                  getTransactionDetails();
                }}
              />
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionHeader;
